<template>

  <v-container fluid>
    
    <!-- 프린트 정보 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog_print" @keydown.esc="dialog_print = false" max-width="800px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t('steplist_label1')}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="dialog_print = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-data-table
                :headers="print_headers"
                :items="printItem"
                :no-data-text="$t('common_nodata')"
                hide-default-footer
                class="datatablestyle"
                item-key="IDX"
                >
                <template v-slot:header.STEP_NAME>
                  <label class="cheader_normal" >{{$t("steplist_col5")}}</label>
                </template>
                <template v-slot:header.PRINT_DATE>
                  <label class="cheader_normal" >{{$t("steplist_col10")}}</label>
                </template>                
              </v-data-table>              
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn" rounded large @click="dialog_print = false">{{$t("common_close")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>    
        
    <!-- 링크 입력 팝업 -->
    <v-row align="center"  justify="center" >
      <v-dialog scrollable overlay-color="#000000FF" persistent v-model="link_dialog" @keydown.esc="link_dialog = false" 
        :fullscreen="$vuetify.breakpoint.smAndDown ? true : false"
        :width="$vuetify.breakpoint.smAndDown ? '100%' : '600px'"
        class="none_radius">
        
        <v-card class="dialog_round pa-10">

          <v-card-text>

            <v-row align="center" justify="center" dense>
              <v-col cols="12" align="center"> <!-- 해상도 조절 컬럼 -->

                <v-row dense align="center" justify="center" class="mt-5 mt-md-10 ma-0">
                  <v-col cols="12" md="10" align="start"  class="ma-0 pa-0">
                    <p class="text-md-h6 text-subtitle-2 text-left ma-0 pa-0 dialog_subtitle_eng">{{$t("steplist_label2")}}</p>
                  </v-col>
                  <v-col cols="12" md="10" class="ma-0 pa-0">
                    <v-text-field 
                      class="none_radius" color="black" placeholder="Link"
                      single-line v-model="LINKADDR" 
                      :height="$vuetify.breakpoint.smAndDown ? 40 : 50"
                      outlined dense hide-details/>
                  </v-col>
                </v-row>    

            </v-col>
          </v-row>
        </v-card-text>

          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large  @click="link_dialog = false">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large  @click="save_link">{{$t("common_save")}}</v-btn>
            </v-row>
          </v-card-actions>

        </v-card>
      </v-dialog>  
    </v-row>

    <!-- 이미지 크롭 팝업 (가로) -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="crop_dialog" @keydown.esc="crop_dialog = false" max-width="500px">
        <v-card class="dialog_round pa-10">
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t("common_crop")}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="crop_dialog = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <div style="width:100%;height:500px;">
              <vueCropper
                ref="cropper_land"
                :img="imgSrc"
                :outputType="option.outputType"
                :fixed="option.fixed"
                :fixedNumber="option.fixedNumber"
                :full="option.full"
                :canMove="option.canMove"
                :canMoveBox="option.canMoveBox"
                :fixedBox="option.fixedBox"
                :original="option.original"
                :autoCrop="option.autoCrop"
                :autoCropWidth="option.autoCropWidth"
                :autoCropHeight="option.autoCropHeight"
                :centerBox="option.centerBox"
                :high="option.high"
                :infoTrue="option.infoTrue"
                :maxImgSize="option.maxImgSize"
                :enlarge="option.enlarge"
                :mode="option.mode"
                :limitMinSize="option.limitMinSize"
                />
            </div>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large @click="crop_dialog = false">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large @click="cropimg">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- 추가/수정 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog" @keydown.esc="close" max-width="600px">
        <v-card class="dialog_round pa-10">
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{ dialogTitle }}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="close"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row dense> 
                <v-text-field v-model="editedItem.COM_NAME" :label="$t('common_userinfo_label2')" disabled></v-text-field>
              </v-row>
              <v-row dense> 
                <v-text-field v-model="editedItem.EVENT_NAME" :label="$t('common_userinfo_label3')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                <v-select v-model="editedItem.STEPTYPE_IDX" :items="steptypeList" :label="$t('steplist_col4')" item-text="STEP_NAME" item-value="IDX"/>
              </v-row>

              <!-- 행사별 커스텀 기본정보              
              <v-row v-for="item in infoItem" :key="item.INPUT_CODE" dense>
                <template v-if="item.LANTYPE == 2">
                  <template v-if="item.MAXLINES == 1">
                    <v-textarea dense no-resize outlined height="70" v-if="item.USETYPE == 1" v-model="editedItem['INFO'+item.INPUT_CODE]" :label="getColumnName(item)" :rules="engrules"></v-textarea>
                  </template>
                  <template v-else>
                    <v-text-field v-if="item.USETYPE == 1" v-model="editedItem['INFO'+item.INPUT_CODE]" :label="getColumnName(item)" :rules="engrules"></v-text-field>
                  </template>
                </template>
                <template v-else>
                  <template v-if="item.MAXLINES == 1">
                    <v-textarea dense no-resize outlined height="70" style="vertical-align:middle"
                      v-if="item.USETYPE == 1" v-model="editedItem['INFO'+item.INPUT_CODE]" :label="getColumnName(item)"></v-textarea>
                  </template>
                  <template v-else>
                    <v-text-field v-if="item.USETYPE == 1" v-model="editedItem['INFO'+item.INPUT_CODE]" :label="getColumnName(item)"></v-text-field>
                  </template>
                </template>
              </v-row>
              --> 

              <!-- 행사별 커스텀 기본정보 -->        
              <div v-for="item in infoItem" :key="item.INPUT_CODE">
                <template v-if="item.USETYPE == 1">
                  <template v-if="item.LANTYPE == 4">
                    <v-row dense>
                      <label>{{item.NAME}}</label>
                    </v-row>
                    <template v-if="editedItem['INFO'+item.INPUT_CODE] != null && editedItem['INFO'+item.INPUT_CODE] != undefined && editedItem['INFO'+item.INPUT_CODE].length > 0">
                      <v-row dense  justify="center" >
                        <img  :height="item.HEIGHT" :width="item.WIDTH" :src="editedItem['INFO'+item.INPUT_CODE]" class="image">
                      </v-row>
                      <v-row dense justify="center" class="mt-3">
                        <!-- <v-icon style="width:80px;height:40px;" size="40" color="gray" @click="showImage(item.INPUT_CODE)">mdi-magnify-expand</v-icon> -->
                        <v-icon style="width:80px;height:40px;" size="40" color="gray" @click="fileSelect(item)">mdi-pencil</v-icon>
                        <v-icon style="width:80px;height:40px;" size="40" color="gray" @click="clearFile(item.INPUT_CODE)">mdi-window-close</v-icon>
                      </v-row>
                    </template>
                    <template v-else>
                      <v-row dense class="image-border2" align="center" justify="center">
                        <v-icon style="width:100px;height:100px;" size="100" color="#EDEDED" @click="fileSelect(item)">mdi-image</v-icon>
                        <!-- <v-icon style="width:100px;height:100px;" size="100" color="#EDEDED" @click="linkadd(item.INPUT_CODE)">mdi-link</v-icon> -->
                      </v-row>
                    </template>
                  </template>
                  <template v-else>
                    <template v-if="item.LANTYPE == 2">
                      <template v-if="item.MAXLINES == 1">
                        <v-row dense>
                          <v-textarea dense no-resize outlined height="70" v-if="item.USETYPE == 1" v-model="editedItem['INFO'+item.INPUT_CODE]" :label="getColumnName(item)" :rules="[v => !v || !/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(v) || $t('common_engrule')]"></v-textarea>
                        </v-row>
                      </template>
                      <template v-else>
                        <v-row dense>
                          <v-text-field v-if="item.USETYPE == 1" v-model="editedItem['INFO'+item.INPUT_CODE]" :label="getColumnName(item)" :rules="[v => !v || !/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(v) || $t('common_engrule')]"></v-text-field>
                        </v-row>
                      </template>
                    </template>
                    <template v-else>
                      <template v-if="item.MAXLINES == 1">
                        <v-row dense>
                          <v-textarea dense no-resize outlined height="70" style="vertical-align:middle"
                            v-if="item.USETYPE == 1" v-model="editedItem['INFO'+item.INPUT_CODE]" :label="getColumnName(item)"></v-textarea>
                        </v-row>
                      </template>
                      <template v-else>
                        <v-row dense>
                          <v-text-field v-if="item.USETYPE == 1" v-model="editedItem['INFO'+item.INPUT_CODE]" :label="getColumnName(item)"></v-text-field>
                        </v-row>
                      </template>
                    </template>
                  </template>
                </template>
              </div>




              <v-row dense>
                  <v-text-field :rules="[v => !v || !/[^0-9-]/.test(v) || this.$t('steplist_msg1')]" v-model="editedItem.TEL" :label="$t('common_userinfo_label6')"></v-text-field>
              </v-row>
              <v-row dense>
                  <v-text-field :rules="[v => Number.isInteger(Number(v)) || $t('common_numberrules')]" v-model="editedItem.PRINT_NUMBER" :label="$t('common_userinfo_label14')"></v-text-field>
              </v-row>
              <v-row dense>
                  <nationdialog :nationname="editedItem.NAMEKOR" @callback="nationcallback" :label="$t('common_userinfo_label12')"></nationdialog>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large  @click="close">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large  @click="save">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>

    <!-- 엑셀등록 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="excel_dialog" @keydown.esc="excel_dialog = false" max-width="600px">
        <v-card class="dialog_round pa-10">
          <v-card-title>
            <span class="dialog_title">{{$t('steplist_label3')}}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-progress-linear :indeterminate="excel_prog"/>
              </v-row>

              <v-row class="mt-3">
                <v-select v-model="excelItem.STEPTYPE_IDX" :items="steptypeList" :label="$t('steplist_col4')" item-text="STEP_NAME" item-value="IDX"/>
              </v-row>
              <v-row>
                  <nationdialog :nationname="excelItem.NAMEKOR" @callback="nationcallbackExcel" :label="$t('common_userinfo_label12')"></nationdialog>
              </v-row>
              <v-row >
                <v-file-input
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" 
                  :label="$t('steplist_label4')" v-model="uploadFile" dense></v-file-input>
              </v-row>
              <v-row justify="center" class="mt-5">
                <v-btn class="dialog_cancel_btn mr-5" rounded large @click="excel_dialog = false">{{$t("common_close")}}</v-btn>
                <v-btn rounded color="primary" @click="uploadExcel()">{{$t('steplist_label5')}}</v-btn>  
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>  
    </v-row>


    <v-row align="center" dense>
      <v-col cols="12" md="2" sm="12" xs="12">
        <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      <v-spacer/>
      <template v-if="grade == 99">
        <v-col cols="6" md="3" sm="6" xs="6" class="pa-0">
          <comdialog  :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
        </v-col>
        <v-col cols="6" md="3" sm="6" xs="6" class="pa-0">
          <eventdialog :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
        </v-col>
      </template>
      <template v-else>
        <v-col cols="6" md="3" sm="6" xs="6" class="pa-0">
          <eventdialog :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
        </v-col>
      </template>
      <v-col cols="6" md="2" sm="6" xs="6" class="pa-0">
        <v-text-field 
          dense single-line clearable
          @keyup.enter="search_run" 
          v-model="search_keyword" 
          :placeholder="$t('common_search_holder')"
          outlined height="43"
          color="#808080"
          hide-details
          class="ml-3"
          />
      </v-col>
      <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center">        
        <v-btn style="width:94%" class="search_btn_freesize" 
          :data-my-variable="$i18n.locale === 'ko' ? 'true' : 'false'"
          outlined large @click="search_run">{{$t("common_search")}}</v-btn>
      </v-col>
    </v-row>

    <v-row no-gutters dense justify="end" align="center">
      
      <!-- <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center"> </v-col> -->

        <!-- 
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" style="width:94%" class="search_btn_freesize" 
            :data-my-variable="$i18n.locale === 'ko' ? 'true' : 'false'"
            elevation="0" outlined large @click="printtest()">{{$t('steplist_label6')}}</v-btn>
          </template>
          <span>{{$t('steplist_label7')}}</span>
        </v-tooltip>
        -->        

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" style="color:#000000;background:#f2f2f2" class="mr-1" elevation="1" small @click="printtest()"><v-icon>mdi-printer</v-icon></v-btn>
          </template>
          <span>{{$t('steplist_label7')}}</span>
        </v-tooltip>            

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" style="color:#000000;background:#f2f2f2" class="mr-3" elevation="1" small @click="deleteall()"><v-icon>mdi-delete</v-icon></v-btn>
          </template>
          <span>{{$t('steplist_label9')}}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" style="color:#000000;background:#f2f2f2" class="mr-1" elevation="1" small @click="newinsert()"><v-icon>mdi-account-plus</v-icon></v-btn>
            <!-- <v-btn v-on="on" v-bind="attrs" style="width:94%" class="blue_btn_freesize" elevation="0" outlined large @click="newinsert">개별등록</v-btn> -->
          </template>
          <span>{{$t('steplist_label11')}}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" style="color:#000000;background:#f2f2f2" class="mr-1" elevation="1" small @click="newexcelinsert()"><v-icon>mdi-account-multiple-plus</v-icon></v-btn>
            <!-- <v-btn v-on="on" v-bind="attrs" style="width:94%" class="yellow_btn_freesize" elevation="0" outlined large @click="newexcelinsert()">단체등록</v-btn> -->
          </template>
          <span>{{$t('steplist_label13')}}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" style="color:#000000;background:#f2f2f2" class="mr-3" elevation="1" small @click="downloadExcel()"><v-icon>mdi-microsoft-excel</v-icon></v-btn>
            <!-- <v-btn v-on="on" v-bind="attrs" style="width:94%" class="search_btn_freesize" elevation="0" outlined large @click="downloadExcel()">{{$t('eventinvit_label23')}}</v-btn> -->
          </template>
          <span>{{$t('steplist_label15')}}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" style="color:#ffffff;background:#4e6ef7" elevation="1" small @click="startDownload()"><v-icon>mdi-file-download</v-icon></v-btn>
            <!-- <v-btn v-on="on" v-bind="attrs" style="width:94%" color="#4e6ef7" large rounded @click="startDownload()"><v-icon color="white">cloud_download</v-icon></v-btn> -->
          </template>
          <span>{{$t("common_downexcel")}}</span>
        </v-tooltip>
      
  </v-row>

  <v-row dense no-gutters>
    <label class="total_label">{{$t("common_total")}}</label><label class="total_label">{{totalcnt}}</label>
  </v-row>
    
  <v-row align="start">
    <v-col>
      <!-- 테이블 -->
      <v-data-table
        :headers="headers"
        :items="itemList"
        :no-data-text="$t('common_nodata')"
        hide-default-footer
        show-select
        v-model="selectList"
        class="datatablestyle"
        :items-per-page="pagerow"
        :search="search"  
        item-key="IDX"
        :loading="loading"
        height="620px"
        >

        <template v-slot:header.SORT>
          <a :class="sort_name=='SORT'?'cheader_sortselect':'cheader_sort'" @click="customsort('SORT')">{{$t('steplist_col1')}}</a>
        </template>
        <template v-slot:header.COM_NAME>
          <a :class="sort_name=='COM_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('COM_NAME')">{{$t('steplist_col2')}}</a>
        </template>
        <template v-slot:header.EVENT_NAME>
          <a :class="sort_name=='EVENT_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('EVENT_NAME')">{{$t('steplist_col3')}}</a>
        </template>
        <template v-slot:header.STEP_NAME>
          <a :class="sort_name=='STEP_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('STEP_NAME')">{{$t('steplist_col4')}}</a>
        </template>
        <template v-slot:header.INFO1>
          <a :class="sort_name=='INFO1'?'cheader_sortselect':'cheader_sort'" @click="customsort('INFO1')">{{$t('steplist_col5')}}</a>
        </template>
        <template v-slot:header.TEL>
          <a :class="sort_name=='TEL'?'cheader_sortselect':'cheader_sort'" @click="customsort('TEL')">{{$t('steplist_col6')}}</a>
        </template>
        <template v-slot:header.PRINT_NUMBER>
          <a :class="sort_name=='PRINT_NUMBER'?'cheader_sortselect':'cheader_sort'" @click="customsort('PRINT_NUMBER')">{{$t('steplist_col7')}}</a>
        </template>
        <template v-slot:header.NAMEKOR>
          <a :class="sort_name=='NAMEKOR'?'cheader_sortselect':'cheader_sort'" @click="customsort('NAMEKOR')">{{$t('steplist_col8')}}</a>
        </template>
        <template v-slot:header.REG_DATE>
          <a :class="sort_name=='REG_DATE'?'cheader_sortselect':'cheader_sort'" @click="customsort('REG_DATE')">{{$t('steplist_col9')}}</a>
        </template>
        <template v-slot:header.PRINT_DATE>
          <a :class="sort_name=='PRINT_DATE'?'cheader_sortselect':'cheader_sort'" @click="customsort('PRINT_DATE')">{{$t('steplist_col10')}}</a>
        </template>

        <template v-slot:header.actions>
          <label class="cheader_normal" >{{$t('steplist_col11')}}</label>
        </template>
        

        <template v-slot:item.actions="{ item }">  
            <v-icon class="mr-2" small @click="edit_item(item)">mdi-pencil</v-icon>
            <v-icon small @click="delete_item(item)">mdi-delete</v-icon>
        </template>     

        <template v-slot:item.PRINT_DATE="{ item }">  
            <a @click="getprintlist(item.IDX, item.EVENT_IDX)">{{ item.PRINT_DATE }}</a>
        </template>     

      </v-data-table>
    </v-col>
  </v-row>

  <!-- 하단 페이징 영역 -->
  <v-row align="start">
    <v-col cols="12" md="1"/>
    <v-col cols="12" md="2">
      <v-text-field
        v-model="search"
        append-icon="search"
        :label="$t('common_filter')"
        single-line
        hide-details
        outlined height="43"
        color="#808080"
        dense
        />
    </v-col>
    <v-col cols="12" md="6" class="d-flex justify-center">
      <v-btn v-if="bottompage > 10" icon  small @click="prev()"><v-icon dark>mdi-chevron-left</v-icon></v-btn>
      <span v-for="n in subpage" :key="n.id">
          <span v-if="page == bottompage-1+n">
              <v-btn color="red" icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
          <span v-else>
              <v-btn icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
      </span>
      <v-btn v-if="subpage == 10" icon small @click="next()" ><v-icon dark>mdi-chevron-right</v-icon></v-btn>
    </v-col>
    <v-col cols="12" md="2">
      <v-select
        v-model="pagerow"
        :items="pagerow_combo"
        item-text="NAME"      
        item-value="VALUE"
        :label="$t('common_rownum')"
        min-width="150px"
        outlined height="43"
        color="#808080"
        dense
        ></v-select>
    </v-col>
    <v-col cols="12" md="1"/>
  </v-row>

  
  

  </v-container>
</template>

<script>
//import dateFormat from 'dateformat'
import 'cropperjs/dist/cropper.css';
import { VueCropper } from 'vue-cropper'; //교체용 크롭 라이브러리

import XLSX from 'xlsx'
import calculateSize from 'calculate-size'
import cmvalidation from '../assets/js/cmvalidation.js'
// eslint-disable-next-line no-unused-vars
import DRBackground from '../dragndrop/DRBackground.js'
// eslint-disable-next-line no-unused-vars
import DRComponent from '../dragndrop/DRComponent.js'
// eslint-disable-next-line no-unused-vars
import DRModel from '../dragndrop/DRModel.js'
import FontFaceObserver from 'fontfaceobserver';

export default {

    components:{
      VueCropper
    },

    data: () => ({

      //파일 업로드
      uploadFile : null,

      useInfo:{},
      //필수 페이징 파라메터
      totalcnt : 0,       //전체 아이템 개수
      page : 0,
      maxpage : 0,        //전체 페이지 개수
      startpage : 1,      //시작 인덱스
      bottompage : 1,     //하단 페이징 번호의 시작점을 계산하기 위한 변수
      subpage : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수
      loading : false,    //로딩 표시

      //CRUD 관련
      dialogTitle: '추가하기',   //다이얼로그 제목
      editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
      dialog:false,
      
      excel_dialog: false,
      excel_prog: false,

      defaultItem: {
          NAME:'',
          ENAME:'',
          COMNAME:'',
          TEL:'',
          TEAM:'',
          GRADE:'',
          NATION:'KR',
          NAMEKOR: '대한민국',
          COM_IDX:null,
          COM_NAME:'',
          EVENT_IDX:null,
          EVENT_NAEM:'',
          PRINT_NUMBER:null,
      },
      editedItem: {},
      excelItem: {},
      
      infoItem:[],    //행사별 기본접수양식 커스텀 정보

      //테이블 정의
      headers: [
        {text: '순서', value: 'SORT', width:100,sortable: false, align:'center' },
        {text: '기업명', value: 'COM_NAME', width:200,sortable: false, align:'center' },
        {text: '행사명', value: 'EVENT_NAME', width:200,sortable: false, align:'center' },
        {text: '관계자구분', value: 'STEP_NAME', width:150,sortable: false, align:'center'},
        {text: '이름', value: 'INFO1', width:150,sortable: false, align:'center'},
        {text: '전화번호', value: 'TEL', width:150,sortable: false, align:'center' },
        {text: '비밀번호', value: 'PRINT_NUMBER', width:100,sortable: false, align:'center' },
        {text: '국가', value: 'NAMEKOR', width:120,sortable: false, align:'center' },
        {text: '등록일시', value: 'REG_DATE', width:200,sortable: false, align:'center' },
        {text: '출력일시', value: 'PRINT_DATE', width:200,sortable: false, align:'center' },
        {text: '수정/삭제', value: 'actions', width:100,sortable: false, align:'center'}
      ],
      itemList: [],
      steptypeList: [],

      //검색 파라메터
      sort_name: 'REG_DATE',
      sort_type: true,    //true : DESC, false: ASC
      
      search_keyword : '',
      search: '',         //필터링용 검색어

      //한 페이지 ROW 개수 설정
      pagerow : 20,       //한 페이지에 보여줄 row수
      pagerow_combo : [
          {NAME:'20', VALUE:20}
        , {NAME:'50', VALUE:50}
        , {NAME:'100', VALUE:100}
        , {NAME:'200', VALUE:200}
      ],    

      SEARCH_COM_IDX: null,
      SEARCH_COM_NAME: '',
      SEARCH_EVENT_IDX: null,
      SEARCH_EVENT_NAME: '',
      grade : 0,

      //명찰출력 테스트
      designList:null,
      fontList:[],
      comfontList:new Map(),
      selectList: [],
      
      link_dialog: false,
      link_index:0,
      LINKADDR:"",

      //신규 크롭 파라메터
      option: {
        img: "",
        size: 1,
        full: true,
        outputType: "jpg",
        canMove: true,
        fixed: true,          //크롭박스 비율 고정
        fixedNumber: [1,1],  //크롭박스 비율
        fixedBox: false,      //true면 크롭박스 크기 조절 안됨
        original: false,      //true면 이미지의 원본 크기로 불러와지고 false면 편집창 기준에 맞게 불러와진다.
        canMoveBox: true,
        autoCrop: true,       //true면 자동으로 크롭박스가 표시됨.
        autoCropWidth:300,    //크롭박스의 가로 크기 fixed가 true면 비율대로
        autoCropHeight:300,   //크롭박스의 세로 크기 
        centerBox: true,
        high: false,
        cropData: {},
				enlarge: 1,
        mode: 'contain',
        maxImgSize: 1200,
        limitMinSize: [100, 100]
      },            
      crop_dialog:false,
      photo_index:'',
      imgSrc:'',

      dialog_print:false,
      printItem:[],
      print_headers: [
        {text: '이름', value: 'STEP_NAME', sortable: true, align:'center'},
        {text: '출력일시', value: 'PRINT_DATE', sortable: false, align:'center' }
      ],

    }),

    beforeDestroy(){
      //아이폰의 경우 찌거기 제거
      let indexcnt = navigator.userAgent.toLowerCase().indexOf("mac os x");
      if(indexcnt > -1){
        let elements = document.getElementsByName("imageinputcamera");
        for(var i=0, len=elements.length ; i != len; ++i){
            elements[0].parentNode.removeChild(elements[0]);
        }
      }
    },

    mounted(){

      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
      this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
      this.grade = this.$session.get("GRADE");

      this.loadsteptype();  //해당 스텝 타입 읽어오기
      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("Login");
      }

      //폰트 읽기
      this.$http.post(this.$host+'/api/FontList',{
        search_keyword:""
      },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
      .then((result)=>{
          
          if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

              const list = result.data.resultData;
              this.fontList.splice(0, this.fontList.length);   //데이터 초기화
              list.forEach(element => {
                //폰트 등록
                //var temp_font = new FontFace(element.NAME, "url('"+element.FONTURL+"')");
                //document.fonts.add(temp_font);
                this.fontList.push(element);
              });

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }
      })
      // eslint-disable-next-line no-unused-vars
      .catch((error)=>{
          
      });

    },

    create(){

    },

    methods: {

      //선택정보 삭제
      deleteall(){

        //console.log("print selectList : " +  JSON.stringify(this.selectList));
        if(this.selectList.length == 0){
          this.$alert(this.$t('steplist_msg2'));
          return;
        }

        this.$confirm(this.$t('steplist_msg3'))
        .then(() => {
          var uploaditem = [];
          this.selectList.forEach(item=>{
            uploaditem.push({STEPUSER_IDX:item.IDX, EVENT_IDX:item.EVENT_IDX, ADMIN_IDX:item.ADMIN_IDX});
          });

          //서버로 전송해서 처리
          this.$http.post(this.$host+'/api/StepDeleteAll',{
              JSONVALUE: escape(JSON.stringify(uploaditem))
            , ADMIN_IDX: this.$session.get("ADMIN_IDX")
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            if(result.data.resultCode == 0){
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t("common_delete_com")).then(()=>{
                this.page = 0;
                this.loadpage(1);
              });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t("common_delete_error"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.$alert(this.$t("common_delete_error"));
          });
          

        });

      },      

      //명찰출력 테스트
      printtest(){
        if(this.SEARCH_COM_IDX == null || this.SEARCH_COM_IDX == undefined || this.SEARCH_COM_IDX == ''){
          this.$alert(this.$t('common_select_com'));
          return;
        }
        if(this.SEARCH_EVENT_IDX == null || this.SEARCH_EVENT_IDX == undefined || this.SEARCH_EVENT_IDX == ''){
          this.$alert(this.$t('common_select_event'));
          return;
        }

        //console.log("print selectList : " +  JSON.stringify(this.selectList));
        if(this.selectList.length == 0){
          this.$alert(this.$t('steplist_msg4'));
          return;
        }

        this.$confirm(this.$t('steplist_msg5'))
        .then(() => {
          //2. 선택된 행사의 모든 이벤트 옵션의 행사 디자인을 가져와야한다.
          this.getEventDesignAll();
        });

      },



      //출력 히스토리
      getprintlist(vidx, eidx){

          this.$http.post(this.$host+'/api/SPrintList',{
                search_keyword: ''
              , sort_name: 'PRINT_DATE'
              , sort_type: 'DESC'
              , page: 1
              , pagerow: 9999
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , EVENT_IDX: eidx
              , STEPUSER_IDX: vidx
              , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                const list = result.data.resultData;
                this.printItem.splice(0, this.printItem.length);
                list.forEach(element => {
                    this.printItem.push(element); 
                });
                this.dialog_print = true;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            
          });

      },      

      async createTicket(){

        //1. 행사별 맵핑정보 양식 => infoItem
        //2. 행사별 명찰디자인    => designList 
        const top_div = document.createElement("div");
        var toppos = 0;

        //선택 순서가 꼬이기 때문에 여기서 선택한 순서대로 리스트를 새로 만듬.
        const seqList = [];
        for(let i=0;i<this.itemList.length;i++){
          for(let j=0;j<this.selectList.length;j++){
            if(this.itemList[i].IDX == this.selectList[j].IDX){
              seqList.push(this.itemList[i]);
              continue;
            }
          }
        }

        for(var i=0;i<seqList.length;i++){

          const user = seqList[i];
          //해당 관람객의 입장료 옵션에 해당하는 명찰디자인 가져오기
          const SELECT_DESIGN = this.designList.get(user.STEPTYPE_IDX);
          //console.log("SELECT_DESIGN : " + JSON.stringify(SELECT_DESIGN));
          const temp1 = document.createElement("div");
          const temp2 = document.createElement("div");
          const bg = new DRModel();
          bg.LAYOUT_WIDTH   = SELECT_DESIGN.COMPONENT_WIDTH;
          bg.LAYOUT_HEIGHT  = SELECT_DESIGN.COMPONENT_HEIGHT;
          bg.LAYOUT_POSX    = 0;
          bg.LAYOUT_POSY    = 0;
          bg.ISBG           = 1;  //bg
          bg.COMPONENT_TYPE = 0; 
          bg.BGTYPE = 0;
          bg.BGCOLOR = "FFFFFFFF";
          
          var front  = new DRBackground(bg, {}, this, true);
          var back   = new DRBackground(bg, {}, this, false);
          temp1.appendChild(front.back_div);
          temp2.appendChild(back.back_div);        

          const matchinfo = [];
          matchinfo.push({name:this.$t('steplist_msg45')});
          matchinfo.push({name:user.INFO1});
          matchinfo.push({name:user.INFO2});
          matchinfo.push({name:user.INFO3});
          matchinfo.push({name:user.INFO4});
          matchinfo.push({name:user.INFO5});
          matchinfo.push({name:user.INFO6});
          matchinfo.push({name:user.INFO7});
          matchinfo.push({name:user.INFO8});
          matchinfo.push({name:user.INFO9});
          matchinfo.push({name:user.INFO10});
          matchinfo.push({name:user.IDX});
          
          await this.createPrintComponent(front, SELECT_DESIGN.COMPONENT.data, matchinfo);
          await this.createPrintComponent(back, SELECT_DESIGN.COMPONENT2.data, matchinfo);

          temp2.style.position  = "absolute";
          temp2.style.height    = SELECT_DESIGN.COMPONENT_HEIGHT+"px";
          temp2.style.width     = SELECT_DESIGN.COMPONENT_WIDTH+"px";
          temp2.style.left      = "0px";
          temp2.style.top       = SELECT_DESIGN.COMPONENT_HEIGHT+"px";
          temp2.style.transform = "rotate(180deg)";

          const page_div = document.createElement("div");
          page_div.style.position  = "absolute";
          page_div.style.height    = ((SELECT_DESIGN.COMPONENT_HEIGHT*2)+12)+"px";
          page_div.style.width     = SELECT_DESIGN.COMPONENT_WIDTH+"px";
          page_div.style.left      = "0px";
          //page_div.style.top       = "0px";
          page_div.style.top       = toppos + "px";
          //page_div.style.overflow  = "hidden";

          page_div.appendChild(temp1);
          page_div.appendChild(temp2);
          
          top_div.appendChild(page_div);
          toppos += 917;  //이렇게 줘야 연속출력잘됨.

        }

        var printContents = top_div.outerHTML;
        //console.log("temp : " + printContents);

        var w = window.open();

        //폰트정보 넘겨주기
        document.fonts.forEach(fontvalue=>{
          w.document.fonts.add(fontvalue);
        });

        /*
        this.fontList.forEach(fontvalue=>{
          w.document.fonts.add(fontvalue);
        });
        this.comfontList.forEach(fontvalue=>{
          w.document.fonts.add(fontvalue);
        });
        */

        w.document.write(printContents);
        w.document.write('<scr' + 'ipt type="text/javascript">' + 'window.onload = function() { window.print(); window.close(); };' + '</sc' + 'ript>');
        w.document.body.setAttribute("style", "-webkit-print-color-adjust: exact;");  //이거 해줘야 컬러와 이미지 출력됨.
        w.document.close(); // necessary for IE >= 10
        w.focus();

      },      

      //컴포넌트 생성 (명찰 정보를 가지고 명찰생성)
      async createPrintComponent(bg, list, matchinfo){

        //컴포넌트 생성
        for(var i=0;i<list.length;i++){
          
          const element = list[i];

          const model = new DRModel();
          model.ADMIN_IDX     = element.ADMIN_IDX;
          model.EVENT_IDX     = element.EVENT_IDX;
          model.STEP_IDX      = element.STEP_IDX;
          model.IMG           = element.IMG;
          model.LOCALIMG      = null;
          model.ISBG          = element.ISBG;
          model.ISFLIP        = element.ISFLIP;
          model.BGTYPE        = element.BGTYPE;
          model.BGCOLOR       = element.BGCOLOR;
          model.TEXTCOLOR     = element.TEXTCOLOR;
          model.TEXTSIZE      = element.TEXTSIZE;
          model.TEXTFONT      = element.TEXTFONT;
          model.TEXTVALUE     = element.TEXTVALUE;
          model.TEXTALIGN     = element.TEXTALIGN;
          model.TEXTMATCH     = element.TEXTMATCH;
          model.LAYOUT_WIDTH  = parseInt(element.LAYOUT_WIDTH);
          model.LAYOUT_HEIGHT = parseInt(element.LAYOUT_HEIGHT);
          model.LAYOUT_POSX   = parseInt(element.LAYOUT_POSX);
          model.LAYOUT_POSY   = parseInt(element.LAYOUT_POSY);

          model.TEMP_POSX   = model.LAYOUT_POSX;
          model.TEMP_POSY   = model.LAYOUT_POSY;
          model.TEMP_WIDTH  = model.LAYOUT_WIDTH;
          model.TEMP_HEIGHT = model.LAYOUT_HEIGHT;

          model.ZINDEX        = element.ZINDEX;
          model.COMPONENT_TYPE = element.COMPONENT_TYPE;

          //새롭게 타입이 추가됨. 기존에 만들어진 디자인의 경우 호환을 위해 강제로 1처리 = TEXT
          if(element.ISBG == undefined || element.ISBG == null){
            if(element.LAYOUT_WIDTH == 384 && element.LAYOUT_POSX == 0 && element.LAYOUT_POSY == 0){
              model.ISBG = 1; //bg
              //bg는 this.drback에 직접 처리
              bg.updateBackground(model);
              continue;
            }else{
              model.ISBG = 0;
              if(element.COMPONENT_TYPE == undefined || element.COMPONENT_TYPE == null){
                if(element.TEXTVALUE != null && element.TEXTVALUE.length > 0){
                  model.COMPONENT_TYPE = 1; //text
                }else{
                  model.COMPONENT_TYPE = 0; //image
                }
              }
            } 
          }

          //텍스트 타입이면 텍스트 사이즈를 동적으로 처리해줘야한다.
          if(element.COMPONENT_TYPE == 1){
            var contenttext = "";
            if(model.TEXTMATCH == "INPUT"){
              contenttext     = model.TEXTVALUE;
            }else if(model.TEXTMATCH == "1"){
              contenttext     = matchinfo[1].name;
            }else if(model.TEXTMATCH == "2"){
              contenttext     = matchinfo[2].name;
            }else if(model.TEXTMATCH == "3"){
              contenttext     = matchinfo[3].name;
            }else if(model.TEXTMATCH == "4"){
              contenttext     = matchinfo[4].name;
            }else if(model.TEXTMATCH == "5"){
              contenttext     = matchinfo[5].name;
            }else if(model.TEXTMATCH == "6"){
              contenttext     = matchinfo[6].name;
            }else if(model.TEXTMATCH == "7"){
              contenttext     = matchinfo[7].name;
            }else if(model.TEXTMATCH == "8"){
              contenttext     = matchinfo[8].name;
            }else if(model.TEXTMATCH == "9"){
              contenttext     = matchinfo[9].name;
            }else if(model.TEXTMATCH == "10"){
              contenttext     = matchinfo[10].name;
            }else{
              contenttext     = ""; 
            }            

            //폰트 사이즈 동적 조절
            var strs = contenttext.split("\n");
            var adjust_size = 1;
            var text_size = parseInt(model.TEXTSIZE);
            if(strs.length <= 1){
              //한줄
              var rendersize = calculateSize(contenttext, {font:model.TEXTFONT, fontSize:model.TEXTSIZE+"px"});
              if(rendersize.width+10 >= model.LAYOUT_WIDTH){
                //컨텐츠가 영역을 넘어가면 폰트사이즈 조절 진입
                while(parseInt(rendersize.width+10) >= model.LAYOUT_WIDTH && text_size > 1){
                  text_size = parseInt(model.TEXTSIZE - adjust_size);
                  rendersize = calculateSize(contenttext, {font:model.TEXTFONT, fontSize:text_size+'px'});
                  adjust_size++;
                }
                model.TEXTSIZE = parseInt(text_size);
              }
            }else{

              //두줄
              var rendersize1 = calculateSize(strs[0], {font:model.TEXTFONT, fontSize:model.TEXTSIZE+"px", lineHeight:"120%"});
              var rendersize2 = calculateSize(strs[1], {font:model.TEXTFONT, fontSize:model.TEXTSIZE+"px", lineHeight:"120%"});

              if(Math.max(rendersize1.width,rendersize2.width)+10 >= model.LAYOUT_WIDTH 
              || rendersize1.height + rendersize2.height + 10 >= model.LAYOUT_HEIGHT
              ){
                //컨텐츠가 영역을 넘어가면 폰트사이즈 조절 진입
                while( (parseInt(Math.max(rendersize1.width,rendersize2.width)+10) >= model.LAYOUT_WIDTH || parseInt(rendersize1.height+rendersize2.height+4) >= model.LAYOUT_HEIGHT) && text_size > 1){
                  text_size = parseInt(model.TEXTSIZE - adjust_size);
                  rendersize1 = calculateSize(strs[0], {font:model.TEXTFONT, fontSize:text_size+'px', lineHeight:"120%"});
                  rendersize2 = calculateSize(strs[1], {font:model.TEXTFONT, fontSize:text_size+'px', lineHeight:"120%"});
                  adjust_size++;
                }
                model.TEXTSIZE = parseInt(text_size);
              }
            }

            
          }

          if(element.ISBG == 1){
              bg.updateBackground(model);
              continue;
          }

          //컴포넌트 생성.
          //MATCHTYPELIST가 매핑정보다. 명찰의 특정 텍스트 영역에 3번 코드가 매핑되야 한다고 되어있으면 디자인 시에는 
          //3번에 해당하는 영어이름을 넣으라는 정보가 필요했지만 여기서는 실제 영어이름 정보를 매핑해야한다.
          const component = new DRComponent(model, matchinfo, true);
          //컴포넌트가 QR이면 동적으로 생성해줘야한다. 동기방식으로 기다려줘야한다. 생성시 딜레이
          if(model.COMPONENT_TYPE == 2){
            await component.createQRCODE(component);
          }else if(model.COMPONENT_TYPE == 3){
            var photourl = "";
            if(model.TEXTMATCH == "INPUT"){
              photourl     = model.TEXTVALUE;
            }else if(model.TEXTMATCH == "1"){
              photourl     = matchinfo[1].name;
            }else if(model.TEXTMATCH == "2"){
              photourl     = matchinfo[2].name;
            }else if(model.TEXTMATCH == "3"){
              photourl     = matchinfo[3].name;
            }else if(model.TEXTMATCH == "4"){
              photourl     = matchinfo[4].name;
            }else if(model.TEXTMATCH == "5"){
              photourl     = matchinfo[5].name;
            }else if(model.TEXTMATCH == "6"){
              photourl     = matchinfo[6].name;
            }else if(model.TEXTMATCH == "7"){
              photourl     = matchinfo[7].name;
            }else if(model.TEXTMATCH == "8"){
              photourl     = matchinfo[8].name;
            }else if(model.TEXTMATCH == "9"){
              photourl     = matchinfo[9].name;
            }else if(model.TEXTMATCH == "10"){
              photourl     = matchinfo[10].name;
            }else{
              photourl     = ""; 
            }
            await component.createPHOTO(component, photourl);  
          }else if(model.COMPONENT_TYPE == 4){
            var barcodevalue = "";
            if(model.TEXTMATCH == "INPUT"){
              barcodevalue     = model.TEXTVALUE;
            }else if(model.TEXTMATCH == "1"){
              barcodevalue     = matchinfo[1].name;
            }else if(model.TEXTMATCH == "2"){
              barcodevalue     = matchinfo[2].name;
            }else if(model.TEXTMATCH == "3"){
              barcodevalue     = matchinfo[3].name;
            }else if(model.TEXTMATCH == "4"){
              barcodevalue     = matchinfo[4].name;
            }else if(model.TEXTMATCH == "5"){
              barcodevalue     = matchinfo[5].name;
            }else if(model.TEXTMATCH == "6"){
              barcodevalue     = matchinfo[6].name;
            }else if(model.TEXTMATCH == "7"){
              barcodevalue     = matchinfo[7].name;
            }else if(model.TEXTMATCH == "8"){
              barcodevalue     = matchinfo[8].name;
            }else if(model.TEXTMATCH == "9"){
              barcodevalue     = matchinfo[9].name;
            }else if(model.TEXTMATCH == "10"){
              barcodevalue     = matchinfo[10].name;
            }else{
              barcodevalue     = ""; 
            }            
            await component.createBARCODE(component, barcodevalue);                          
          }
          bg.addComponent(component, false);

        }

      },


      getEventDesignAll(){
        
        const selectEvent = new Map();
        this.selectList.forEach(item=>{
          selectEvent.set(item.STEPTYPE_IDX, item.STEPTYPE_IDX);
        });
        const select_step_idxs = Array.from(selectEvent.keys());
                    
        //선택된 행사의 모든 명찰디자인 가져오기
        this.$http.post(this.$host+'/api/DesignAll',
          {
              ADMIN_IDX : this.$session.get("ADMIN_IDX")
            , STEP_IDX : select_step_idxs
            , EVENT_IDX : this.SEARCH_EVENT_IDX
            , COM_IDX : this.SEARCH_COM_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          
          if(result.data.resultCode == 0){
            
            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }
            const list = result.data.resultData;

            this.comfontList.clear();
            this.designList.clear();
            list.forEach(element => {

                var tempobj   = JSON.parse(JSON.stringify(element)); //파싱

                //명찰에 사용된 폰트정보 가져오기
                tempobj.COMPONENT.data.forEach(cp=>{
                  const font = this.fontList.find(ft => ft.CODE === cp.TEXTFONT );
                  var temp_font = new FontFace(font.CODE, "url('"+font.FONTURL+"') format('truetype')");
                  if(!this.comfontList.has(font.CODE)){
                    document.fonts.add(temp_font);                    
                    this.comfontList.set(font.CODE, temp_font);
                  }
                });
                tempobj.COMPONENT2.data.forEach(cp=>{
                  const font = this.fontList.find(ft => ft.CODE === cp.TEXTFONT );
                  var temp_font = new FontFace(font.CODE, "url('"+font.FONTURL+"') format('truetype')");
                  if(!this.comfontList.has(font.CODE)){
                    document.fonts.add(temp_font);
                    this.comfontList.set(font.CODE, temp_font);
                  }
                });

                this.designList.set(tempobj.STEP_IDX, tempobj);
            });
            
            //업체폰트 정보
            const flist = result.data.fontData;
            
            flist.forEach(element => {
              const font = this.fontList.find(ft => ft.CODE === element.NAME );
              var temp_font = new FontFace(font.CODE, "url('"+font.FONTURL+"') format('truetype')");
              if(!this.comfontList.has(font.CODE)){
                document.fonts.add(temp_font);
                this.comfontList.set(font.CODE, temp_font);
              }
            });
            
            

            if(this.comfontList.size > 0){
              const tempfontlist = Array.from(this.comfontList.values());
              Promise.all(tempfontlist.map(this.observeFontLoad))
              .then(() => {
                  
                  this.insertPrintInfo();
              })
              .catch(error => {
                  console.log(`font load error : ${error}`);
                  //3.상태값을 변경하고 출력 리스트에 추가한다.
                  this.insertPrintInfo();
              })
            }else{
              //로드할께 없으면
              
              //3.상태값을 변경하고 출력 리스트에 추가한다.
              this.insertPrintInfo();
            }            


          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동
          }

          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.$alert(this.$t('steplist_msg6'));
          });

      },

      //프린트 정보 추가
      insertPrintInfo(){
          
        this.$http.post(this.$host+'/api/SPrintInsertList',
          {
            SELECTDATA: escape(JSON.stringify(this.selectList))
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          
          if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

            //4. 선택 관람객의 명찰을 그리고 출력한다.
            this.createTicket();

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }else{
            this.$alert(this.$t('steplist_msg7'));
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          this.$alert(this.$t('steplist_msg7'));
        });
        
      },    


      startDownload(){

        this.$confirm(this.$t('steplist_msg8')).then(() => {

          if(this.SEARCH_COM_IDX == null){
            this.$alert(this.$t('common_select_tcom'));
            return;
          }
          
          if(this.SEARCH_EVENT_IDX == null){
            this.$alert(this.$t('common_select_tevent'));
            return;
          }

          this.loading = true;
          this.$http.post(this.$host+'/api/StepUserListExcel',{
                search_keyword: this.search_keyword == null || this.search_keyword == undefined ?  '' : escape(this.search_keyword)
              , sort_name:this.sort_name
              , sort_type: this.sort_type==true ? "DESC" : "ASC" 
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , EVENT_IDX: this.SEARCH_EVENT_IDX
              , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            this.loading = false;
            
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
                
                const list = result.data.resultData;
                var item_sheet = XLSX.utils.json_to_sheet(list);
                
                //컬럼명 수정
                item_sheet.A1 = {v:this.$t('steplist_excel1')};
                item_sheet.B1 = {v:this.$t('steplist_excel2')};
                item_sheet.C1 = {v:this.$t('steplist_excel3')};
                item_sheet.D1 = {v:this.$t('steplist_excel4')};
                item_sheet.E1 = {v:this.$t('steplist_excel5')};
                item_sheet.F1 = {v:this.$t('steplist_excel6')};
                item_sheet.G1 = {v:this.$t('steplist_excel7')};
                item_sheet.H1 = {v:this.$t('steplist_excel8')};
                item_sheet.I1 = {v:this.$t('steplist_excel9')};
                item_sheet.J1 = {v:this.$t('steplist_excel10')};
                item_sheet.K1 = {v:this.$t('steplist_excel11')};
                item_sheet.L1 = {v:this.$t('steplist_excel12')};
                item_sheet.M1 = {v:this.$t('steplist_excel13')};
                item_sheet.N1 = {v:this.$t('steplist_excel14')};
                item_sheet.O1 = {v:this.$t('steplist_excel15')};
                item_sheet.P1 = {v:this.$t('steplist_excel16')};
                item_sheet.Q1 = {v:this.$t('steplist_excel17')};
                item_sheet.R1 = {v:this.$t('steplist_excel18')};

                //컬럼별 너비
                var wscols = [{wch:20},{wch:30},{wch:10},{wch:10},{wch:20,},{wch:20},{wch:20},{wch:20},{wch:20},{wch:20},{wch:10},{wch:10}];
                item_sheet['!cols'] = wscols;

                var wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, item_sheet, this.$t('steplist_msg9'));
                XLSX.writeFile(wb, this.$t('steplist_msg10')+Date.now().toString()+'.xlsx');


            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

        });

      },


      downloadExcel(){
        this.$confirm(this.$t('steplist_msg11')).then(() => {

            if(this.SEARCH_COM_IDX == null){
              this.$alert(this.$t('common_select_tcom'));
              return;
            }
            if(this.SEARCH_EVENT_IDX == null){
              this.$alert(this.$t('common_select_tevent'));
              return;
            }

            var templist = [];
            //templist.push({"A":"","B":"","C":"","D":"","E":"","F":"","G":"","H":"","I":"","J":"","K":"","L":""});
            
            
            for(var i=0;i<1000;i++){
              templist.push({"A":"","B":"","C":"","D":"","E":"","F":"","G":"","H":"","I":"","J":"","K":"","L":"","M":""});
            }
            
            
            var item_sheet = XLSX.utils.json_to_sheet(templist);
            //상단 컬럼명 수정
            item_sheet.A1 = {v:this.getColumnName(this.infoItem[0])};
            //item_sheet.A1.c.push({t:'s', z:'@'});
            item_sheet.B1 = {v:this.getColumnName(this.infoItem[1])};
            item_sheet.C1 = {v:this.getColumnName(this.infoItem[2])};
            item_sheet.D1 = {v:this.getColumnName(this.infoItem[3])};
            item_sheet.E1 = {v:this.getColumnName(this.infoItem[4])};
            item_sheet.F1 = {v:this.getColumnName(this.infoItem[5])};
            item_sheet.G1 = {v:this.getColumnName(this.infoItem[6])};
            item_sheet.H1 = {v:this.getColumnName(this.infoItem[7])};
            item_sheet.I1 = {v:this.getColumnName(this.infoItem[8])};
            item_sheet.J1 = {v:this.getColumnName(this.infoItem[9])};
            item_sheet.K1 = {v:this.$t('steplist_msg12')};
            item_sheet.L1 = {v:this.$t('steplist_msg13')};
            item_sheet.M1 = {v:this.$t('steplist_msg14')};

            //item_sheet['!autofilter'] = {};
            

            //컬럼별 너비
            var wscols = [{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:20},{wch:15},{wch:15}];
            item_sheet['!cols'] = wscols;
            
            //전화번호 텍스트 타입 처리
            for(var j=0;j<1000;j++){
              for(var k=0;k<12;k++){
                var cell_ref1 = item_sheet[XLSX.utils.encode_cell({c:k, r:j})];
                cell_ref1.t = 's';
                cell_ref1.z = '@';
              }
            }
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, item_sheet, this.$t('steplist_msg15'));
            XLSX.writeFile(wb, this.SEARCH_EVENT_NAME+this.$t('steplist_msg16'));

        });
      },

      getColumnName(item){
        var temp = "";
        if(item.USETYPE == 0){
          temp = this.$t('steplist_msg17');
          return temp;
        }else{
          temp = item.NAME;
        }
        if(item.REQTYPE == 1){
          temp += this.$t('steplist_msg18');
        }
        if(item.LANTYPE == 2){
          temp += this.$t('steplist_msg19');
        }
        return temp;
      },


      uploadExcel(){
        
        const korean = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;

        if(this.excelItem.STEPTYPE_IDX == null || this.excelItem.STEPTYPE_IDX == undefined){
          this.$alert(this.$t('steplist_msg20'));
          return;
        }

        if(this.uploadFile == null){
          this.$alert(this.$t('steplist_msg21'));
          return;
        }
        this.$confirm(this.$t('steplist_msg22')).then(() => {
          
          this.excel_prog = true;
          const reader = new FileReader();

          reader.onload = ()=>{
            var fileData = reader.result;
            let workbook = XLSX.read(fileData, {type : 'binary'});  
            var sheetNameList = workbook.SheetNames; // 시트 이름 목록 가져오기 
            var firstSheetName = sheetNameList[0]; // 첫번째 시트명            
            var firstSheet = workbook.Sheets[firstSheetName]; // 첫번째 시트 
            let wrokjson = XLSX.utils.sheet_to_json(firstSheet, {defval:""});

            //빈값 제거
            var uploaditem = [];
            wrokjson.forEach(element=>{
              var nullcnt = 0;
              for(var j=0;j<this.infoItem.length;j++){
                var column_name = this.getColumnName(this.infoItem[j])
                if(element[column_name] == null || String(element[column_name]).length < 1){
                  nullcnt++;
                }
              }

              //비교 - 전부다 값이 비어있으면 무시하고 값이 입력된 경우에만 업로드 대상
              if(nullcnt != this.infoItem.length){
                uploaditem.push(element);
              }

            })

            if(uploaditem.length < 1){
              this.$alert(this.$t('steplist_msg23'));
              this.excel_prog = false;
              return;
            }
            
            //데이터 검증 
            var checkflag = true;
            var read_column = Object.keys(wrokjson[0]);

            //엑셀파일과 기본양식 컬럼값 비교
            for(var k=0;k<this.infoItem.length;k++){
              
              if(this.infoItem[k].USETYPE == 1){
                if(read_column[k] != this.getColumnName(this.infoItem[k])){
                  checkflag = false;
                  break;
                }
              }
            }
            if(!checkflag){
              this.$alert(this.$t('steplist_msg24'));
              this.excel_prog   = false;
              this.excel_dialog = false;
              return;
            }

            //console.log("uploaditem len : "+uploaditem.length);

            for(var i=0;i<uploaditem.length;i++){
              if(!checkflag){
                break;
              }
              var element = uploaditem[i];
              //console.log("element len : " + JSON.stringify(element));
              for(var j=0;j<this.infoItem.length;j++){
                var column_name = this.getColumnName(this.infoItem[j])
                if(this.infoItem[j].USETYPE == 0){
                  //사용안함이면 검증 패스
                  continue;
                }
                if(this.infoItem[j].REQTYPE == 1){  //필수입력
                  if(element[column_name] == null || String(element[column_name]).length < 1){
                    this.$alert(i+1+this.$t('steplist_msg25')+column_name+this.$t('steplist_msg26'));
                    checkflag = false;
                    break;
                  }
                }
                if(this.infoItem[j].LANTYPE == 2){
                  //영문만 사용 가능한 경우
                  if(korean.test(element[column_name])){
                    this.$alert(i+1+this.$t('steplist_msg25')+column_name+this.$t('steplist_msg27'));
                    checkflag = false;
                    break;
                  }
                }
              }

              //기본정보 체크
              if(element[this.$t('steplist_msg12')] == null || String(element[this.$t('steplist_msg12')]).length < 1){
                this.$alert(i+1+this.$t('steplist_msg28'));
                checkflag = false;
                break;
              }
              const mobileVal1 = /[^0-9-]/g;
              if(mobileVal1.test(String(element[this.$t('steplist_msg12')]).trim())){
                this.$alert(i+1+this.$t('steplist_msg29'));
                checkflag = false;
                return;
              } 

              if(element[this.$t('steplist_msg13')] == null || String(element[this.$t('steplist_msg13')]).length < 1){
                this.$alert(i+1+this.$t('steplist_msg30'));
                checkflag = false;
                break;
              }
              if(String(element[this.$t('steplist_msg13')]).length != 4){
                this.$alert(i+1+this.$t('steplist_msg31'));
                checkflag = false;
                break;
              }

              const numberVal1 = /[^0-9]/g;
              if(numberVal1.test(element[this.$t('steplist_msg13')])){
                this.$alert(i+1+this.$t('steplist_msg32'));
                checkflag = false;
                return;
              } 

              if(element[this.$t('steplist_msg14')] != null || String(element[this.$t('steplist_msg14')]).length > 0){
                if(numberVal1.test(element[this.$t('steplist_msg14')])){
                  this.$alert(i+1+this.$t('steplist_msg33'));
                  checkflag = false;
                  return;
                } 
              }

            }

            if(!checkflag){
              this.excel_prog   = false;
              this.excel_dialog = false;
              return;
            }

            //서버로 전송해서 처리
            this.$http.post(this.$host+'/api/StepUserUpload',{
                JSONVALUE: escape(JSON.stringify(uploaditem))
              , INFOVALUE: escape(JSON.stringify(read_column))
              , NATION: this.excelItem.NATION
              , STEPTYPE_IDX: this.excelItem.STEPTYPE_IDX
              , EVENT_IDX: this.SEARCH_EVENT_IDX
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , TEL_COLUMN: this.$t("steplist_msg12")
              , PW_COLUMN: this.$t("steplist_msg13")
              , SORT_COLUMN: this.$t("steplist_msg14")
              , LAN_CODE:this.$i18n.locale
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
            .then((result)=>{
              this.excel_prog   = false;
              this.excel_dialog = false;
              if(result.data.resultCode == 0){
                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
                  this.$alert(this.$t('common_insert_msg')).then(()=>{
                    this.page = 0;
                    this.loadpage(1);
                  });

              }else if(result.data.resultCode == 2){
                //로그인 필요
                this.$alert(this.$t("common_tokener"));
                this.$session.clear("ADMIN_IDX");
                this.$session.clear("COM_IDX");
                this.$session.clear("ACNT_IDX");
                this.$session.clear("GRADE");
                this.$session.clear("COM_NAME");
                this.$session.clear("ACCESSTOKEN");
                this.$session.clear("REFLASHTOKEN");
                this.$router.push('Login');   //로그인 페이지로 이동

              }else{
                this.$alert(this.$t("common_insert_fail"));
              }
            })
            // eslint-disable-next-line no-unused-vars
            .catch((error)=>{
              this.excel_prog   = false;
              this.excel_dialog = false;
              this.$alert(this.$t("common_insert_fail"));
            });
            
          }
          reader.readAsBinaryString(this.uploadFile);  //비동기로 파일을 읽어서
        });


      },      

      customsort(sortname){
        this.sort_name = sortname;
        this.sort_type = !this.sort_type;
        this.loadpage(this.page);
      },

      prev(){
          this.bottompage = this.bottompage - 10 >= 1 ? this.bottompage - 10 : 1;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage + this.subpage - 1; //이전을 누르면 가장 끝 번호 선택
          this.loadpage(temp_page);
      },
      next(){
          this.bottompage = this.bottompage + 10 <= this.maxpage ? this.bottompage + 10 : this.maxpage;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage;
          this.loadpage(temp_page);
      },

      makepaging(){
        var div1 = this.totalcnt / this.pagerow; 
        var div2 = this.totalcnt % this.pagerow;
        if(div2 == 0){  
            this.maxpage = parseInt(div1);    
        }else{
            this.maxpage = parseInt(div1+1);
        }
        if(this.bottompage == 1){
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
        }
      },

      loadpage(p){

          this.itemList.splice(0, this.itemList.length);   //데이터 초기화
          this.selectList.splice(0, this.selectList.length);   
          
          if(this.SEARCH_COM_IDX == null){
            this.$alert(this.$t('common_select_tcom'));
            return;
          }
          if(this.SEARCH_EVENT_IDX == null){
            this.$alert(this.$t('common_select_tevent'));
            return;
          }

          this.loading = true;
          this.page = p;

          this.$http.post(this.$host+'/api/StepUserList',{
                search_keyword: this.search_keyword == null || this.search_keyword == undefined ?  '' : escape(this.search_keyword)
              , sort_name:this.sort_name
              , sort_type: this.sort_type==true ? "DESC" : "ASC" 
              , page: this.page
              , pagerow: this.pagerow
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , EVENT_IDX: this.SEARCH_EVENT_IDX
              , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

                this.totalcnt = result.data.totalcnt;
                this.makepaging();
                const list = result.data.resultData;
                
                list.forEach(element => {
                    //console.log("step : " + JSON.stringify(element));
                    this.itemList.push(element); 
                });

                this.loading = false;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      initpage(){
        this.designList = new Map();
        
        this.getInfoItemList();
        this.loadpage(1);
      },      

      //행사별 기본접수양식 가져오기
      getInfoItemList(){
        
        this.infoItem.splice(0, this.infoItem.length);   //데이터 초기화
        
        if(this.SEARCH_COM_IDX == null){
            return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          return;
        }

        this.$http.post(this.$host+'/api/InputEventList',{
              ADMIN_IDX: this.$session.get("ADMIN_IDX")
            , COM_IDX:   this.SEARCH_COM_IDX
            , EVENT_IDX: this.SEARCH_EVENT_IDX
        },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          if(result.data.resultCode == 0){
              //console.log(JSON.stringify(result.data));
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.useInfo = result.data.useData;
              const list = result.data.resultData;
              list.forEach(element => {
                  this.infoItem.push(element); 
              });
          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.loading = false;
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          this.loading = false;
          if(error.message == 'Request failed with status code 429')
          {
            this.$alert(this.$t("common_reqer"));
          }else{
            this.$alert(error.message);
          }
        });
      },      

      //다이얼로그 닫기
      close () {
        this.dialog     = false
        this.dialog_pw  = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      //추가 저장
      save () {
        
        const korean = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;

        if(this.editedItem.STEPTYPE_IDX  == undefined || this.editedItem.STEPTYPE_IDX.length < 1){
          this.$alert(this.$t('steplist_msg34'));
          return;
        } 

        for(var i=1;i<=10;i++){

          if(this.infoItem[i-1].USETYPE == 0){
            //사용 안함이면 패스
            continue;
          }
          if(this.infoItem[i-1].REQTYPE == 1){
            //필수 입력이면 체크
            if(this.editedItem['INFO'+i] == undefined || this.editedItem['INFO'+i].length < 1){
              this.$alert(this.infoItem[i-1].NAME + this.$t('steplist_msg26'));
              return;
            }
          }
          if(this.infoItem[i-1].LANTYPE == 2){
            //영문만 사용 가능한 경우
            if(korean.test(this.editedItem['INFO'+i])){
              this.$alert(this.infoItem[i-1].NAME+this.$t('steplist_msg35'));
              return;
            }
          }
        }
        if(this.editedItem.TEL  == undefined || this.editedItem.TEL.length < 1){
          this.$alert(this.$t('steplist_msg36'));
          return;
        } 
        const mobileVal1 = /[^0-9-]/g;
        if(mobileVal1.test(this.editedItem.TEL)){
          this.$alert(this.$t('steplist_msg37'));
          return;
        } 

        if(this.editedItem.PRINT_NUMBER == null){
          this.$alert(this.$t('steplist_msg38'));
          return;
        }
        if(this.editedItem.PRINT_NUMBER.length != 4){
          this.$alert(this.$t('steplist_msg38'));
          return;
        }
        const passVal1 = /[^0-9]/g;
        if(passVal1.test(this.editedItem.PRINT_NUMBER)){
          this.$alert(this.$t('steplist_msg40'));
          return;
        } 

        let tel = this.editedItem.TEL == null || this.editedItem.TEL == undefined ? "" : this.editedItem.TEL.replace(/[^0-9]/g, "");
        if (tel.startsWith("10") && tel.length === 10) {
          tel = "0" + tel;
        }

        if (this.editedIndex > -1) {

          //수정
          this.loading = true;
          this.$http.post(this.$host+'/api/StepUserUpdate',{
                INFO1: escape(this.editedItem.INFO1.replace(/\t/g, ""))
              , INFO2: escape(this.editedItem.INFO2)
              , INFO3: escape(this.editedItem.INFO3)
              , INFO4: escape(this.editedItem.INFO4)
              , INFO5: escape(this.editedItem.INFO5)
              , INFO6: escape(this.editedItem.INFO6)
              , INFO7: escape(this.editedItem.INFO7)
              , INFO8: escape(this.editedItem.INFO8)
              , INFO9: escape(this.editedItem.INFO9)
              , INFO10: escape(this.editedItem.INFO10)
              , TEL: escape(tel)
              , NATION: this.editedItem.NATION
              , PRINT_NUMBER: this.editedItem.PRINT_NUMBER
              , STEPTYPE_IDX: this.editedItem.STEPTYPE_IDX
              , ADMIN_IDX:this.$session.get("ADMIN_IDX")
              , IDX: this.editedItem.IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                this.$alert(this.$t("common_edit_msg")).then(()=>{
                  const p = this.page;
                  this.page = 0;
                  this.loadpage(p);
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
                this.$alert(this.$t("common_edit_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_edit_fail"));
          });


        }else{
          
          //신규
          this.loading = true;
          this.$http.post(this.$host+'/api/StepUserInsert',{
                INFO1: escape(this.editedItem.INFO1.replace(/\t/g, ""))
              , INFO2: escape(this.editedItem.INFO2)
              , INFO3: escape(this.editedItem.INFO3)
              , INFO4: escape(this.editedItem.INFO4)
              , INFO5: escape(this.editedItem.INFO5)
              , INFO6: escape(this.editedItem.INFO6)
              , INFO7: escape(this.editedItem.INFO7)
              , INFO8: escape(this.editedItem.INFO8)
              , INFO9: escape(this.editedItem.INFO9)
              , INFO10: escape(this.editedItem.INFO10)
              , TEL: escape(tel)
              , NATION: this.editedItem.NATION
              , PRINT_NUMBER: this.editedItem.PRINT_NUMBER
              , STEPTYPE_IDX: this.editedItem.STEPTYPE_IDX
              , EVENT_IDX: this.editedItem.EVENT_IDX
              , ADMIN_IDX:this.$session.get("ADMIN_IDX")
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                this.$alert(this.$t('common_insert_msg')).then(()=>{
                  const p = this.page;
                  this.page = 0;
                  this.loadpage(p);
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t("common_insert_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_insert_fail"));
          });


        }

        this.close()
      },      

      //검색
      search_run(){
        this.loadpage(1);
      },
      
      //신규 추가
      newinsert(){

        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }

        this.dialogTitle = this.$t('common_insert_title');
        this.editedIndex  = -1;
        this.editedItem = Object.assign({}, this.defaultItem)

        this.editedItem.COM_IDX     = this.SEARCH_COM_IDX;
        this.editedItem.COM_NAME    = this.SEARCH_COM_NAME;
        this.editedItem.EVENT_IDX   = this.SEARCH_EVENT_IDX;
        this.editedItem.EVENT_NAME  = this.SEARCH_EVENT_NAME

        this.dialog = true;
      },

      
      newexcelinsert(){
        
        this.uploadFile = null;
        
        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }

        this.excelItem = Object.assign({}, this.defaultItem)
        this.excelItem.COM_IDX     = this.SEARCH_COM_IDX;
        this.excelItem.COM_NAME    = this.SEARCH_COM_NAME;
        this.excelItem.EVENT_IDX   = this.SEARCH_EVENT_IDX;
        this.excelItem.EVENT_NAME  = this.SEARCH_EVENT_NAME
        this.excel_dialog = true;

      },


      //아이템 수정
      edit_item(item){
        this.dialogTitle = this.$t('common_edit_title');
        this.editedIndex = this.itemList.indexOf(item)
        //this.editedItem = item;
        this.editedItem = Object.assign({}, item);
        this.editedItem.PRINT_NUMBER = this.editedItem.PRINT_NUMBER.toString();
        this.dialog = true;
      },

      //아이템 삭제
      delete_item(item){

        this.$confirm(this.$t("common_delete_msg"))
        .then(() => {
          this.loading = true;
          this.$http.post(this.$host+'/api/StepUserDelete',{
              IDX:item.IDX
            , ADMIN_IDX:item.ADMIN_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t("common_delete_com")).then(()=>{
                const p = this.page;
                this.page = 0;
                this.loadpage(p);
              });
              
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동
              
            }else{
              this.$alert(this.$t("common_delete_fail"));
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t("common_delete_error"));
          });      

        });

      },

      //업체선택 콜백
      comdialogcb(val){
        if(val.NAME.length > 0){
          this.editedItem.COM_NAME = val.NAME;
          this.editedItem.COM_IDX  = val.IDX;
        }else{
          this.$alert(this.$t('common_select_company'));
          return;
        }
      },

      //검색조건 업체 설정
      comsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_COM_NAME = val1.NAME;
          this.SEARCH_COM_IDX  = val1.IDX;
          this.$session.set("COM_IDX", val1.IDX);
          this.$session.set("COM_NAME", val1.NAME);
          this.SEARCH_EVENT_IDX = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }else{
          this.SEARCH_COM_NAME = '';
          this.SEARCH_COM_IDX  = null;
          this.SEARCH_EVENT_IDX = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }
        this.itemList.splice(0, this.itemList.length);   //데이터 초기화
      },

      //검색조건 업체 설정
      eventsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_EVENT_NAME = val1.NAME;
          this.SEARCH_EVENT_IDX  = val1.IDX;
          this.$session.set("EVENT_IDX", val1.IDX);
          this.$session.set("EVENT_NAME",val1.NAME);
          this.getInfoItemList();
          this.loadsteptype();  //해당 스텝 타입 읽어오기
        }else{
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          this.steptypeList.splice(0, this.steptypeList.length);   //데이터 초기화
        }
        this.loadpage(1);
      },

      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
          this.SEARCH_COM_IDX    = null;
          this.SEARCH_COM_NAME   = '';
          this.SEARCH_EVENT_IDX  = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          this.itemList.splice(0, this.itemList.length);   //데이터 초기화
      },

      //국가선택 콜백
      nationcallback(var1){
        if(var1.NAMEKOR.length > 0){
          this.editedItem.NATION  = var1.NACODE;
          this.editedItem.NAMEKOR = var1.NAMEKOR;
        }
      },

      //국가선택 콜백
      nationcallbackExcel(var1){
        if(var1.NAMEKOR.length > 0){
          this.excelItem.NATION  = var1.NACODE;
          this.excelItem.NAMEKOR = var1.NAMEKOR;
        }
      },

      //스텝타입 가져오기.
      loadsteptype(){
        
        this.$http.post(this.$host+'/api/StepList',{
              ADMIN_IDX: this.$session.get("ADMIN_IDX")
            , EVENT_IDX: this.SEARCH_EVENT_IDX
        },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          
          if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

              const list = result.data.resultData;
              this.steptypeList.splice(0, this.steptypeList.length);   //데이터 초기화
              list.forEach(element => {
                  this.steptypeList.push(element); 
              });

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          
        });

      },


      //이미지 상세보기
      showImage(input_code){
        this.$viewerApi({
          images: [this.editedItem['INFO'+input_code]],
        })
      },

      clearFile(input_code){
        this.editedItem['INFO'+input_code] = null;
        this.$forceUpdate();
      },

      linkadd(input_code){
        this.LINKADDR = "";
        this.link_index = input_code;
        this.link_dialog = true;
      },

      fileSelect(item){
        const changefunction = this.changefile;
        var input = document.createElement("input");
        input.style = "display:none";
        input.name = "imageinputcamera";
        input.type = "file";
        input.accept = ".jpg,.jpeg,.png"; // 확장자가 xxx, yyy 일때, ".xxx, .yyy"

        let indexcnt = navigator.userAgent.toLowerCase().indexOf("mac os x");
        if(indexcnt > -1){
          //아이폰, 아이패드, 맥
          //input이 실제 돔에 추가되야 사진수정에 따른 onchange가 작동한다.
          document.body.appendChild(input);
          input.onchange = function (event) {
            //추가된 input 제거
            document.body.removeChild(input);
            changefunction(event.target.files[0], item);
          };
        }else{
          input.onchange = function (event) {
            changefunction(event.target.files[0], item);
          };
        }
        input.click();
      },


      //링크 저장
      save_link(){
        const urlVal = /https?:\/\//;
        const checklink = cmvalidation.checkValReg(this.LINKADDR, urlVal, -1, 255, false);
        if(checklink == 1){
          this.$alert(this.$t('steplist_msg41'));
          return false;
        }else if(checklink == 2){
          this.$alert(this.$t('steplist_msg42'));
          return false;
        }else if(checklink == 4){
          this.$alert(this.$t('steplist_msg43'));
          return false;
        }              
        this.editedItem['INFO'+this.link_index] = this.LINKADDR;
        this.link_dialog = false;
      },


      //이미지 선택시 크롭창 띄우기
      changefile(file, item){
        if(file.size/1024/1024 > 10){
          this.$alert(this.$t('steplist_msg44'));
          return;
        }
        //이미지 크롭 팝업 띄우기
        const reader = new FileReader();
        reader.onload = (event)=>{
          this.photo_index           = item.INPUT_CODE;
          this.option.autoCropWidth  = item.WIDTH;
          this.option.autoCropHeight = item.HEIGHT;
          this.option.fixedNumber    = [item.WIDTH, item.HEIGHT];
          this.crop_dialog = true;
          this.imgSrc = event.target.result;  //이게 blob데이터
        }
        reader.readAsDataURL(file);  //비동기로 파일을 읽어서
      },


      //이미지 크롭시
      cropimg(){
        //이미지 크롭 
        this.$refs.cropper_land.getCropBlob(blob=>{
          this.crop_dialog = false;
          this.uploadimage(blob);
        });
      },


      //url의 마지막 /이후의 값을 가져온다.
      async getLastPath(path_url){
        var array = path_url.split('/');
        return array[array.length-1];
      },

      async uploadimage(blob){

        //s3에 파일 업로드 경로
        var albumPhotosKey = encodeURIComponent("visitor") + "/" + encodeURIComponent(this.editedItem.EVENT_IDX) + "/";

        //이미지 업로드
        var filename = Date.now().toString()+".jpg";
        var photoKey = albumPhotosKey + filename;   
        const stored1 = await this.$s3.upload({
                                                Bucket: "blueorigin-mice-image",
                                                Key: photoKey,
                                                Body: blob,
                                                ACL: "public-read"
                                              }).promise();
          
        this.editedItem['INFO'+this.photo_index] = stored1.Location;
        this.$forceUpdate();
        

      },

      //폰트로드 감지
      observeFontLoad(fontFace) {
        const observer = new FontFaceObserver(fontFace.family);
        return observer.load();
      },

    },
  
}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>

</style>